export default __webpack_public_path__ + "static/media/infra-gate.f409ebff.webp";